import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'awair-floor-plan-editor-sidebar-header',
  templateUrl: './floor-plan-editor-sidebar-header.component.html',
  styleUrls: ['./floor-plan-editor-sidebar-header.component.scss']
})
export class FloorPlanEditorSidebarHeaderComponent implements OnInit {

  @Input() name: string = 'Floor List';
  @Input() isSelected: boolean = false;
  @Input() isFloorPlanEdited: boolean = false;

  @Output() clickBack: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

  onClickBack(isFloorPlanEdited: boolean): void {
    if (!isFloorPlanEdited || confirm('Changes will not be saved.\nAre you sure you want to close?')) {
      this.clickBack.emit();
    }
  }
}
